(function () {
  function clean(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function fromFilename(src) {
    var file = (src || '').split('?')[0].split('/').pop() || '';
    file = file.replace(/\.(webp|png|jpe?g|gif|svg)$/i, '').replace(/[-_]+/g, ' ');
    file = file.replace(/\b(1280x485px|600x205px|parts and accessories|black ops auto works|cdn|files)\b/ig, ' ');
    return clean(file);
  }

  function nearbyLabel(img) {
    var scope = img.closest('.card-text-overlay,.logo-item,.slide-image,.product-card,.halo-item,[data-section-id]') || img.parentElement;
    var title = scope && scope.querySelector('.title,h1,h2,h3,[class*=title]');
    var label = title ? clean(title.textContent) : '';
    return label || clean(img.getAttribute('title')) || fromFilename(img.currentSrc || img.src) || 'Black Ops Auto Works carbon fiber auto parts and performance upgrades';
  }

  function fixAltText() {
    document.querySelectorAll('img').forEach(function (img) {
      if (clean(img.getAttribute('alt'))) return;
      var src = img.currentSrc || img.src || '';
      var label = nearbyLabel(img);

      if (/BlackOps-banner/i.test(src)) label = 'Black Ops Auto Works carbon fiber auto parts and performance upgrades';
      if (/Jeep_Grand_Cherokee/i.test(src)) label = 'Jeep Grand Cherokee carbon fiber parts and performance upgrades';
      if (/Dodge_Charger/i.test(src)) label = 'Dodge Charger carbon fiber hoods and exterior upgrades';
      if (/Dodge-RAM-TRX/i.test(src)) label = 'RAM TRX carbon fiber hood and performance parts';
      if (/Porsche/i.test(src)) label = 'Porsche carbon fiber parts and performance upgrades';
      if (/McLaren/i.test(src)) label = 'McLaren carbon fiber parts and performance upgrades';
      if (/Lamborghini/i.test(src)) label = 'Lamborghini carbon fiber parts and performance upgrades';
      if (/Camaro/i.test(src)) label = 'Chevrolet Camaro carbon fiber parts and performance upgrades';
      if (/Corvette/i.test(src)) label = 'Chevrolet Corvette carbon fiber parts and performance upgrades';
      if (/Mustang/i.test(src)) label = 'Ford Mustang carbon fiber parts and performance upgrades';
      if (/Bronco/i.test(src)) label = 'Ford Bronco parts and performance upgrades';
      img.setAttribute('alt', label);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAltText);
  } else {
    fixAltText();
  }

  window.addEventListener('load', fixAltText);
  window.setTimeout(fixAltText, 750);
  window.setTimeout(fixAltText, 2000);
})();
